module.exports = __webpack_public_path__ + "static/media/WW.5527ca9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/WW.svg
// module id = 393
// module chunks = 0